<template>
  <section
    class="accruals-rules-empty"
    :data-testid="testId"
  >
    <div class="accruals-rules-empty__content">
      <div class="accruals-rules-empty__illustration-wrap">
        <img
          :src="assets.EMPTY_ILLUSTRATION"
          alt=""
          class="accruals-rules-empty__illustration"
        />
      </div>

      <p class="accruals-rules-empty__message">{{ displayMessage }}</p>

      <div
        v-if="showActions"
        class="accruals-rules-empty__actions"
      >
        <base-button
          primary
          class="shadow-off primaryBtn"
          label="Add rule"
          :image="assets.ICON_PLUS_WHITE"
          image-alt=""
          data-testid="accruals-configuration-page__add-rule-btn"
          @click="$emit('add-rule')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import {
  ACCRUALS_CONFIG_ASSETS,
  EMPTY_STATE_COPY,
} from '../accrualsConfigurationConstants';

export default {
  name: 'AccrualsRulesEmptyState',
  props: {
    tabId: { type: String, default: '' },
    message: { type: String, default: '' },
    showActions: { type: Boolean, default: true },
    testId: {
      type: String,
      default: 'accruals-configuration-page__empty-state',
    },
  },
  data() {
    return {
      assets: ACCRUALS_CONFIG_ASSETS,
    };
  },
  computed: {
    copy() {
      return EMPTY_STATE_COPY[this.tabId] || EMPTY_STATE_COPY['estimation-rules'];
    },
    displayMessage() {
      if (this.message) return this.message;
      return this.copy.description;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsRulesEmptyState.scss';
</style>
